"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ColumnOrder = void 0;
class ColumnOrder {
    static deserialize(obj) {
        return new ColumnOrder(obj);
    }
    constructor(columns) {
        this.columns = columns;
    }
    serialize() {
        return this.columns;
    }
    // eslint-disable-next-line no-unused-vars
    validate(lookup) {
        return this.columns.every(column => column.column && column.nodeId && !!lookup(column.nodeId));
    }
}
exports.ColumnOrder = ColumnOrder;
